<template>
  <transition name="modal">
    <div
      ref="modal"
      class="modal"
      tabindex="0"
      @keydown.esc="close()"
    >
      <div
        class="modal__overlay"
        @click="close"
      />
      <div
        :class="'modal__content '+modalContainerCustomClass"
        role="dialog"
        aria-labelledby="modalTitle"
        @keydown.esc="close"
      >
        <header class="modal__header">
          <h2
            id="modalTitle"
            class="modal__title"
          >
            <slot name="header">
              Modal
            </slot>
          </h2>
        </header>

        <div
          :class="customClass"
        >
          <slot>
            Text here
          </slot>
        </div>

        <footer class="modal__footer">
          <slot name="footer">
            <v-button
              size="lg"
              color="secondary"
              has-min-width
              @click="close"
            >
              Cancel
            </v-button>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
  import Button from '../Button'

  export default {
    components: {
      'v-button': Button
    },
    props: {
      customClass: {
        type: String,
        default:'modal__body'
      },
      modalContainerCustomClass: {
        type: String,
        default: ''
      }
    },
    mounted() {
      this.$refs.modal.focus();
    },

    methods: {
      close: function () {
        this.$emit('close')
      }
    },

  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .modal {
    position: fixed;
    z-index: $z-modal;
    top: 0;
    left: 0;
    padding: 1rem;
    display: flex;
    width: 100%;
    height: 100%;
    transition: opacity .3s ease;
    align-items: center;
    justify-content: center;
    &__overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba($black, .5);
    }
    &__content {
      position: relative;
      display: flex;
      flex-direction: column;
      max-width: 100%;
      min-height: 30vh;
      max-height: 70vh;
      width: 640px;
      margin: 0 auto;
      background-color: $white;
      border-top: solid 2px rgba($tangerine, .3);
      border-radius: 4px;
      transition: all .3s ease;
      box-shadow: 0 2px 5px 0 rgba($bali, 0.25);
    }
    &__title {
      margin-bottom: 0;
    }
    &__header {
      padding: 1rem 1.5rem;
      margin-bottom: 1.5rem;
      box-shadow: 0 2px 5px 0 rgba($bali, 0.25);
    }
    &__body {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
      overflow: auto;
      flex: 1;
    }
    &__footer {
      text-align: right;
      padding: 1rem 1.5rem 1rem;
    }
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal__content,
  .modal-leave-active .modal__content {
    transform: scale(1.1);
  }

</style>
